// extracted by mini-css-extract-plugin
export default {"card":"style_card__xp3oW","customerCard":"style_customerCard__aMdvE"};